import * as API from "../../api"
import * as ActionTypes from "../action-types";
import { REDUX } from '../../../constants'

/**
 * ThirdParty Library
 */
 import {
    message
} from 'antd'

/**
 * Get Device
 */

export const get_device_request = dvid => dispatch => {

    API
    .getDeviceInfoByDVID(dvid)
    .then(info => {
        
        try {
            const {
                deviceStatics,
                deviceState
            } = info

            dispatch(get_device_success(deviceStatics,deviceState))


        } catch(err) {
            message.error('Error in getting devices. Refresh page?')
        }

    })
}

const get_device_success = (deviceStatics,deviceState) => {
    return {
        type: ActionTypes.GET_DEVICE,
        deviceStatics,
        deviceState
    };
}

/**
 * Get Devices
 */

 export const get_devices_request = dvids => dispatch => {

    let dvidBatch = []

    dvids.map((vid, index) => {

        dvidBatch.push(vid)

        if( 
            (index+1) % REDUX.REDUX_DEVICE_BATCH_GET_SIZE === 0
            ||
            index+1 === dvids.length
        ) {
            dispatch(batch_get_devices_request(dvidBatch))
            dvidBatch = []
        }

        return null
    })
 }

/**
 * Batch Get Device
 */
 export const batch_get_devices_request = dvids => dispatch => {

    API
    .getDeviceInfoBatch(dvids)
    .then(info => {
        try {
            const {
                deviceStatics,
                deviceStates
            } = info

            dispatch(batch_get_devices_success(deviceStatics,deviceStates))


        } catch(err) {
            message.error('Error in batch getting devices. Refresh page?')
        }

    })
}

const batch_get_devices_success = (deviceStatics,deviceStates) => {
    return {
        type: ActionTypes.GET_DEVICES,
        deviceStatics,
        deviceStates
    };
}


export const create_device_request = (items, cb = () => {}) => dispatch => {

    API
    .createDevice(
        items
    )
    .then(info => {
        const { device, status, msg } = info

        if(status === 200) {
            dispatch(create_device_success(device))
            cb()
        } else if(status === 401) {
            message.warning(`Failed in creating device. Error: ${msg}`)
        } else {
            message.warning('Failed in creating device. Retry?')
        }

    })
    .finally(() => {
        // cb()
    })
}

const create_device_success = (device) => {
    return {
        type: ActionTypes.CREATE_DEVICE,
        device
    }
}

export const update_device_request = (items, cb = () => {}) => dispatch => {

    API
    .updateDevice(
        items
    )
    .then(info => {
        const { device, status, msg } = info

        if(status === 200) {
            dispatch(update_device_success({ ...device, ...items.device }))
            message.success(msg)
            cb()
        } else if(status === 401) {
            message.warning(`Failed in updating device. Error: ${msg}`)
        } else {
            message.warning('Failed in updating device. Retry?')
        }

    })
    .finally(() => {
        // cb()
    })
}

const update_device_success = (device) => {
    return {
        type: ActionTypes.UPDATE_DEVICE,
        device
    }
}

export const get_device_model_request = () => dispatch => {

    API
    .getDeviceModel()
    .then(info => {

        const { deviceModels, status } = info

        if(status === 200) {
            dispatch(get_device_model_success(deviceModels))
        } else {
            message.warning('Failed in getting device models. Retry?')
        }

    })
    .finally(() => {
        // cb()
    })
}

const get_device_model_success = (deviceModels) => {

    return {
        type: ActionTypes.GET_DEVICE_MODELS,
        deviceModels
    }
}

export const update_device_buzzer_action_request = (items) => dispatch => {

    API
    .updateBuzzerAction(items)
    .then(info => {
        const { msg, status } = info

        if(status === 200) {
            message.success(msg)
        } else {
            message.warning(msg)
        }
    })

    dispatch(update_device_buzzer_success(items))
}

const update_device_buzzer_success = (items) => {
    return {
        type: ActionTypes.UPDATE_DEVICE_BUZZER_ACTION,
        items
    }
}